export type WorkspaceId = "event-os" | "pnl";

const WORKSPACE_KEY = "eventos_workspace";

function getStorage(type: "session" | "local"): Storage | null {
  if (typeof window === "undefined") return null;
  return type === "session" ? window.sessionStorage : window.localStorage;
}

export function readWorkspace(): WorkspaceId | null {
  const sessionValue = getStorage("session")?.getItem(WORKSPACE_KEY) ?? null;
  const raw = sessionValue || getStorage("local")?.getItem(WORKSPACE_KEY) || null;
  if (raw === "event-os" || raw === "pnl") return raw;
  return null;
}

export function writeWorkspace(value: WorkspaceId): void {
  const session = getStorage("session");
  const local = getStorage("local");
  session?.setItem(WORKSPACE_KEY, value);
  local?.removeItem(WORKSPACE_KEY);
}

export function clearWorkspace(): void {
  getStorage("session")?.removeItem(WORKSPACE_KEY);
  getStorage("local")?.removeItem(WORKSPACE_KEY);
}
